
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M10.369 44C4.395 43.546.454 39.605 0 33.631V10.413C.484 4.055 4.917 0 11.546 0H32.41C39.44 0 44 4.56 44 11.59v20.864c0 6.63-4.055 11.062-10.413 11.546H10.37z","id":"path-1"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',[_c('mask',{attrs:{"id":"mask-27222233","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#path-1"}})]),_c('path',{attrs:{"fill":"#FACA3F","mask":"url(#mask-27222233)","d":"M0 44h44V0H0z"}})]),_c('g',{attrs:{"fill":"#1D2833","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M19.625 22.217c.171-.075.346-.142.522-.203.056-.02.11-.04.166-.058.182-.057.365-.106.55-.15L12.01 10H10.44l9.091 12.254c.03-.014.063-.022.093-.037zM22.563 21.607c.195 0 .389.016.58.034L31.875 10h-1.563l-7.455 10.09a.463.463 0 01-.718 0L14.688 10h-1.563l8.729 11.639c.234-.021.47-.032.709-.032zM24.76 21.976l.028.01c.23.078.457.167.679.268L34.559 10h-1.568L24.14 21.802c.21.05.418.106.622.174zM22.539 24.286H22.5a4.464 4.464 0 00-.038 8.928h.038a4.464 4.464 0 00.038-8.928z"}}),_c('path',{attrs:{"d":"M25.431 23.23c-.011-.005-.024-.008-.035-.014a6.462 6.462 0 00-.66-.299l-.05-.018a6.12 6.12 0 00-.589-.187l-.15-.038a6.07 6.07 0 00-.522-.099c-.06-.009-.12-.02-.179-.028a6.23 6.23 0 00-.692-.047c-.763 0-1.521.134-2.238.397l-.02.007a5.964 5.964 0 00-.694.309c-.006.003-.012.003-.019.006A6.25 6.25 0 0022.446 35h.054a6.25 6.25 0 002.93-11.77h.001zM22.5 34.107h-.045a5.357 5.357 0 01.045-10.714h.045a5.357 5.357 0 01-.045 10.714z"}})])])])
          )
        }
      }
    